// "About" callout inside a drawer, from the help catalogue (help_content, localized `<key>__<lang>`, base-key fallback) — the shell page
// callout look (.callout + ⓘ). Used by the proforma drawer (concept.proforma: a proforma is a payment request, not an invoice).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHelpEntry } from '../../../services/useHelp';

export default function HelpCallout({ helpKey, testid }) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').slice(0, 2);
  const { entry: h } = useHelpEntry(helpKey, lang, true);   // 47107 A7k: it sits in a drawer the user opened: read its one key now
  if (!h?.body) return null;
  return <div className="callout" data-testid={testid} style={{ marginBottom: 10 }}><span className="ci">i</span><div><b>{h.title}.</b> {h.body}</div></div>;
}
